import * as api from "@/api/paralloy/rbi";
import { ParalloyState } from "./types";
import { ParalloyWeld } from "@/api/paralloy/rbi";
import { ServiceClient } from "@/util";
import { useMutation, useQuery } from "react-query";

export function useWeldList(state: ParalloyState, skip: number, take: number) {
  const subProjectId = state.subProject?.id ?? "";
  const datasheetId = state.datasheet?.datasheetId ?? "";
  const filters = { datasheetId, onlyWeldsNotMade: true, skip, take };

  return useQuery({
    queryKey: ["rbi/welder/welds", { subProjectId, filters }],
    queryFn: () => api.getWelderWeldList(subProjectId, filters),
  });
}

export function useWeldCheckout() {
  return useMutation(async (welds: ParalloyWeld[]) => api.checkoutWelds(welds));
}

export function useCheckedOutWelds() {
  return useQuery({
    queryKey: "rbi/welder/checkout",
    queryFn: () => api.getCheckedOutWelds(),
  });
}

export function useSave() {
  return useMutation(async (welds: ParalloyWeld[]) => {
    await api.saveParalloyWelds(welds);
    ServiceClient.logout();
  });
}
